module.exports = __webpack_public_path__ + "b948002ff5f8629dbd564727854ad1c3.svg";